// Cabecera compartida Ivalro — cerrar desplegables (buscador/menú) al hacer clic fuera,
// y mostrar el número real de artículos en el carrito.

function ivhInitDesplegables() {
  var detalles = document.querySelectorAll('.ivh-menu');
  if (!detalles.length) return;
  document.addEventListener('click', function (e) {
    detalles.forEach(function (d) {
      if (d.open && !d.contains(e.target)) d.removeAttribute('open');
    });
  });
  detalles.forEach(function (d) {
    var enlaces = d.querySelectorAll('a');
    enlaces.forEach(function (a) {
      a.addEventListener('click', function () { d.removeAttribute('open'); });
    });
  });
  // El fondo oscuro (.ivh-menu-scrim) vive DENTRO del <details>, así que un
  // clic ahí no cuenta como "clic fuera" para el listener de arriba y el
  // menú se quedaba abierto sin reaccionar. Lo cerramos explícitamente.
  var scrim = document.querySelector('.ivh-menu-scrim');
  if (scrim) {
    scrim.addEventListener('click', function () {
      document.querySelector('.ivh-menu').removeAttribute('open');
    });
  }
  // Accesibilidad: con el menú abierto la página de fondo no se desplaza,
  // y Escape lo cierra devolviendo el foco al botón del menú.
  detalles.forEach(function (d) {
    d.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('ivh-menu-abierto', d.open);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    detalles.forEach(function (d) {
      if (!d.open) return;
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });
}

function ivhInitBuscador() {
  var raiz = document.querySelector('[data-ivh-buscar]');
  if (!raiz) return;
  var input = raiz.querySelector('[data-ivh-buscar-input]');
  var caja = raiz.querySelector('[data-ivh-buscar-resultados]');
  if (!input || !caja) return;

  var timer = null;
  var ultima = '';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function dinero(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var strings = window.ivhStrings || {};
    var locale = strings.locale || 'es-ES';
    var currency = strings.currency || 'EUR';
    try { return n.toLocaleString(locale, { style: 'currency', currency: currency }); }
    catch (e) { return n.toFixed(2) + ' ' + currency; }
  }

  function miniatura(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=90';
  }

  function pintar(productos, termino) {
    var strings = window.ivhStrings || {};
    if (!productos.length) {
      caja.innerHTML = '<p class="ivh-buscar-vacio">' + (strings.searchNoResults || 'Sin resultados para') + ' «' + esc(termino) + '».</p>';
      caja.hidden = false;
      return;
    }
    var html = productos.map(function (p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      var rebaja = p.compare_at_price_min && parseFloat(p.compare_at_price_min) > parseFloat(p.price);
      return '<a class="ivh-buscar-item" href="' + esc(p.url) + '">' +
        '<span class="ivh-buscar-item-img">' + (img ? '<img src="' + esc(miniatura(img)) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="ivh-buscar-item-txt">' +
          '<span class="ivh-buscar-item-titulo">' + esc(p.title) + '</span>' +
          '<span class="ivh-buscar-item-precio">' + dinero(p.price) +
            (rebaja ? ' <s>' + dinero(p.compare_at_price_min) + '</s>' : '') +
          '</span>' +
        '</span>' +
      '</a>';
    }).join('');
    html += '<a class="ivh-buscar-todos" href="' + (strings.searchUrl || '/search') + '?q=' + encodeURIComponent(termino) + '&type=product">' + (strings.searchSeeAll || 'Ver todos los resultados') + '</a>';
    caja.innerHTML = html;
    caja.hidden = false;
  }

  // La búsqueda predictiva de Shopify tolera erratas y, con un término sin
  // sentido ("xqzwv"), devuelve productos que no tienen nada que ver. Solo se
  // muestran los que contienen alguna palabra buscada (sin tildes, por prefijo
  // de 4 letras), primero los que la llevan en el título.
  function normalizar(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function relevantes(productos, termino) {
    var palabras = normalizar(termino).split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 2; })
      .map(function (w) { return w.slice(0, 4); });
    if (!palabras.length) return productos;
    var conTitulo = [], resto = [];
    productos.forEach(function (p) {
      var titulo = normalizar(p.title + ' ' + p.handle);
      var todo = titulo + ' ' + normalizar([p.product_type, p.vendor, (p.tags || []).join(' '), p.body].join(' '));
      if (palabras.some(function (w) { return titulo.indexOf(w) !== -1; })) conTitulo.push(p);
      else if (palabras.some(function (w) { return todo.indexOf(w) !== -1; })) resto.push(p);
    });
    return conTitulo.concat(resto);
  }

  function buscar(termino) {
    // Comodín al final para que funcione como autocompletado desde la 1ª letra
    // (Shopify solo hace coincidencia por prefijo real con el asterisco).
    var consulta = termino.replace(/\*+$/, '') + '*';
    var raiz = (window.ivhStrings && window.ivhStrings.rootUrl) || '';
    var url = raiz + '/search/suggest.json?q=' + encodeURIComponent(consulta) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || input.value.trim() !== termino) return;
        var productos = (data.resources && data.resources.results && data.resources.results.products) || [];
        pintar(relevantes(productos, termino), termino);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var termino = input.value.trim();
    clearTimeout(timer);
    if (termino.length < 1) { caja.hidden = true; caja.innerHTML = ''; ultima = ''; return; }
    if (termino === ultima) return;
    ultima = termino;
    timer = setTimeout(function () { buscar(termino); }, 180);
  });

  // Volver a mostrar resultados al enfocar si ya hay texto
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 1 && caja.innerHTML) caja.hidden = false;
  });

  // Ocultar resultados al hacer clic fuera o pulsar Escape
  document.addEventListener('click', function (e) {
    if (!raiz.contains(e.target)) caja.hidden = true;
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { caja.hidden = true; input.blur(); }
    if (e.key === 'ArrowDown' && !caja.hidden) {
      var primero = caja.querySelector('a');
      if (primero) { e.preventDefault(); primero.focus(); }
    }
  });
  // Flechas arriba/abajo entre los resultados; Escape vuelve al campo
  caja.addEventListener('keydown', function (e) {
    var enlaces = Array.prototype.slice.call(caja.querySelectorAll('a'));
    var i = enlaces.indexOf(document.activeElement);
    if (i === -1) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); (enlaces[i + 1] || enlaces[0]).focus(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (i === 0) input.focus(); else enlaces[i - 1].focus(); }
    else if (e.key === 'Escape') { caja.hidden = true; input.focus(); }
  });
}

function ivhInitModoOscuro() {
  var KEY = 'ivh-theme';
  var root = document.documentElement;

  function estaOscuro() { return root.getAttribute('data-theme') === 'dark'; }

  function sincronizarBotones() {
    var oscuro = estaOscuro();
    var btns = document.querySelectorAll('[data-ivh-theme-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var titleAttr = oscuro ? (btn.dataset.titleLight || 'Modo claro') : (btn.dataset.titleDark || 'Modo oscuro');
      var labelAttr = oscuro ? (btn.dataset.labelLight || 'Cambiar a modo claro') : (btn.dataset.labelDark || 'Cambiar a modo oscuro');
      btn.setAttribute('aria-pressed', oscuro ? 'true' : 'false');
      btn.setAttribute('title', titleAttr);
      btn.setAttribute('aria-label', labelAttr);
    }
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', oscuro ? '#14161a' : '#faf9f6');
  }

  function alternar() {
    var oscuro = !estaOscuro();
    if (oscuro) root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    try { localStorage.setItem(KEY, oscuro ? 'dark' : 'light'); } catch (e) {}
    sincronizarBotones();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ivh-theme-toggle]');
    if (btn) { e.preventDefault(); alternar(); }
  });

  sincronizarBotones();

  // Si el usuario cambia el tema en otra pestaña, reflejarlo aquí
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    if (e.newValue === 'dark') root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    sincronizarBotones();
  });
}

function ivhInitPopupBienvenida() {
  var popup = document.querySelector('[data-ivh-popup]');
  if (!popup) return;
  var KEY = 'ivh-popup-visto';
  var DIAS = 30;

  function yaVisto() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return false;
      return (Date.now() - parseInt(raw, 10)) < DIAS * 24 * 60 * 60 * 1000;
    } catch (e) { return false; }
  }
  function marcarVisto() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }
  function abrir() {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
    marcarVisto();
  }
  function cerrar() {
    popup.hidden = true;
    document.body.style.overflow = '';
  }

  popup.querySelectorAll('[data-ivh-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) cerrar();
  });

  var copiarBtn = popup.querySelector('[data-ivh-popup-copiar]');
  if (copiarBtn) {
    copiarBtn.addEventListener('click', function () {
      var texto = popup.querySelector('[data-ivh-popup-codigo-texto]');
      var valor = texto ? texto.textContent.trim() : '';
      if (!valor) return;
      var terminado = function () {
        copiarBtn.textContent = copiarBtn.dataset.labelCopied || 'Copiado';
        copiarBtn.setAttribute('data-copiado', '1');
        setTimeout(function () {
          copiarBtn.textContent = copiarBtn.dataset.labelCopy || 'Copiar';
          copiarBtn.removeAttribute('data-copiado');
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(valor).then(terminado).catch(function () {});
      }
    });
  }

  // Si el formulario acaba de enviarse con éxito, se fuerza a mostrar el código aunque ya se hubiera visto antes.
  if (popup.hasAttribute('data-ivh-popup-force')) { abrir(); return; }

  // Carrito y checkout, con o sin prefijo de mercado e idioma (/cart, /en-us/cart, /es-eu/checkouts/...)
  var enRutaExcluida = /^(\/[a-z]{2}(-[a-z]{2})?)?\/(cart|checkout)/i.test(window.location.pathname);
  if (enRutaExcluida || yaVisto()) return;

  var mostrado = false;
  function mostrarUnaVez() {
    if (mostrado || popup.hidden === false) return;
    mostrado = true;
    abrir();
  }

  setTimeout(mostrarUnaVez, 4500);
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY < 40) mostrarUnaVez();
  });
}

function ivcInitCrossAdd() {
  // Delegado: los botones "+" del cross-sell viven dentro del cajón del carrito,
  // que se repinta por AJAX, así que no se pueden enganchar una sola vez al cargar.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ivc-cross-add]');
    if (!btn || btn.disabled) return;

    // Si Dawn tiene una línea del carrito cambiando (quitar/actualizar cantidad),
    // bloquea también este botón: sin esto, un clic aquí a la vez que se elimina
    // otra línea puede pisar los índices de línea a mitad de la petición y
    // provocar el error "El parámetro line no es válido".
    var itemsContainer = document.getElementById('CartDrawer-CartItems') || document.getElementById('main-cart-items');
    if (itemsContainer && itemsContainer.classList.contains('cart__items--disabled')) {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var drawer = document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    btn.disabled = true;
    if (itemsContainer) itemsContainer.classList.add('cart__items--disabled');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
        // Si renderContents ya repintó #CartDrawer-CartItems, esta referencia es
        // del árbol viejo y ya no importa; si no repintó (p. ej. hubo error),
        // libera el bloqueo sobre el contenedor real actual.
        var current = document.getElementById('CartDrawer-CartItems') || document.getElementById('main-cart-items');
        if (current) current.classList.remove('cart__items--disabled');
      });
  });
}

if (!window.__ivhScriptsInit) {
  window.__ivhScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    ivhInitDesplegables();
    ivhInitBuscador();
    ivhInitModoOscuro();
    ivhInitPopupBienvenida();
    ivcInitCrossAdd();
  });
}
